module.exports = __webpack_public_path__ + "4ebca85b.svg";